<script>
    import AddButton from "../../../components/buttons/AddButton.vue"
    import NormalButton from '../../../components/buttons/NormalButton.vue' 
    import axios from 'axios'
    import FormModal from '../../../components/modals/FormModal.vue';

    export default {
        components: { 
            AddButton,
            NormalButton,
            FormModal
        },
        props: {
            addItemClick: Function,        
            disabledResetButton: Boolean,
            disabledDiscardButton: Boolean,
            disabledSaveButton: Boolean,
            discardChanges: Function,
            saveButtonClick: Function,
            saveButtonText: String,
            disabledAddButton: Boolean
        },
        data() {
            return {
                isShowResetModal: false,
                modalTitle: 'Reseting all default deleted items will affect future Tax Companies. Would you like to also apply the changes onto all current Tax Companies?',
                isModalButtonLoading: true,
                resetFormData: {
                    assigneeType: null
                },
                resetButtonText: 'Reset to Default Checklist'
            }
        },
        methods: {
            manageResetFormSubmit() {
                if(this.resetFormData.assigneeType == null) {
                    this.isShowResetModal = true
                    return false
                }
                this.resetButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`
                this.isModalButtonLoading = true
                axios.post(
                route('sb-restore-onboarding-checklist-default-deleted-items'),
                this.resetFormData, {
                })
                .then(response => {
                    this.isShowResetModal = false
                    this.$inertia.visit(route('sb-onboarding-checklist-items-index'), { method: 'get'})
                    this.resetFormData.assigneeType = null
                    this.$toastr.s(response.data.message)
                })
                .catch(err => {
                    this.resetButtonText = `Reset to Default Checklist`
                    this.isModalButtonLoading = false
                    if(err.response.status == 400) {
                        this.$toastr.e(err.response.data.message);
                    }
                })
            },
            hideResetModal() {
                this.resetFormData.assigneeType = null
                this.isShowResetModal = false
                this.isModalButtonLoading = true
            },
            handleAssigneeType(value) {
                this.resetFormData.assigneeType = value
                this.isModalButtonLoading = false
            }
        }
    }
</script>

<template>
    <div class="row justify-content-between">
        <div class="col-auto">
            <div class="col-auto">
                <AddButton 
                    :onClick="addItemClick"
                    :disabled="disabledAddButton || resetButtonText != 'Reset to Default Checklist'"
                >
                    Add Checklist Item
                </AddButton>
            </div>
        </div>

        <div class="col-auto mt-4 mt-sm-0 float-sm-end d-sm-flex">
            <div class="col-auto">
                <NormalButton 
                    :onClick="manageResetFormSubmit"
                    :disabled="disabledResetButton || resetButtonText != 'Reset to Default Checklist'"
                    classes="btn btn-outline-success waves-effect waves-light me-2"
                    v-html="resetButtonText"
                />
            </div>
            <div class="col-auto">
                <NormalButton 
                    :onClick="discardChanges"
                    :disabled="disabledDiscardButton || resetButtonText != 'Reset to Default Checklist'"
                    classes="btn btn-danger me-2"
                >
                    Discard Changes
                </NormalButton>
            </div>
            <div class="col-auto">
                <NormalButton 
                    :onClick="saveButtonClick"
                    :disabled="disabledSaveButton || resetButtonText != 'Reset to Default Checklist'"
                    classes="btn btn-success"
                    v-html="saveButtonText"
                />
            </div>
        </div>
        <FormModal
            :isShow="isShowResetModal"
            :title="modalTitle"
            :isButtonLoading="isModalButtonLoading"
            :isShowSubmitButton="true"
            :isShowCancelButton="true"
            :clickSubmitButton="manageResetFormSubmit"
            submitButtonText="Reset"
            closeButtonText="Cancel"
            @hideModal="hideResetModal"
        >
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 p-2">
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                v-model="resetFormData.assigneeType"
                                value="all_tc"
                                id="assigneeTypeAllTc"
                                @click="handleAssigneeType('all_tc')"
                            />
                            <label
                                class="form-check-label"
                                for="assigneeTypeAllTc"
                            >
                                Yes, apply changes to current Tax Companies as well
                            </label>
                        </div>
                    </div>
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                v-model="resetFormData.assigneeType"
                                value="new_tc"
                                id="assigneeTypeNewTc"
                                @click="handleAssigneeType('new_tc')"
                            />
                            <label
                                class="form-check-label"
                                for="assigneeTypeNewTc"
                            >
                                No, apply changes only to future Tax Companies
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </FormModal>
    </div>
</template>